var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDirectChatOrderTracking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m14.997 483c-1.932 0-3.881-.373-5.737-1.142-5.605-2.322-9.26-7.791-9.26-13.858v-238.75c0-43.975 35.776-79.75 79.75-79.75h232c43.975 0 79.75 35.775 79.75 79.75v113.75c0 43.975-35.775 79.75-79.75 79.75h-230.287l-55.857 55.856c-2.869 2.871-6.706 4.394-10.609 4.394z",
    fill: "#4ab8f7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m311.75 149.5h-116v273.25h116c43.975 0 79.75-35.775 79.75-79.75v-113.75c0-43.975-35.775-79.75-79.75-79.75z",
    fill: "#4a7aff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.25 29h-232c-43.974 0-79.75 35.775-79.75 79.75v113.75c0 43.975 35.776 79.75 79.75 79.75h230.287l55.856 55.856c2.869 2.87 6.706 4.395 10.609 4.394 1.933 0 3.882-.373 5.737-1.142 5.605-2.322 9.26-7.791 9.26-13.858v-238.75c.001-43.975-35.774-79.75-79.749-79.75z",
    fill: "#f2f6fc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m432.25 29h-116v273.25h114.287l55.856 55.856c2.869 2.87 6.706 4.395 10.609 4.394 1.933 0 3.882-.373 5.737-1.142 5.605-2.322 9.26-7.791 9.26-13.858v-238.75c.001-43.975-35.774-79.75-79.749-79.75z",
    fill: "#e9edf5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m225.875 179.5c7.846 0 15.363-6.899 15-15-.364-8.127-6.591-15-15-15-7.846 0-15.363 6.899-15 15 .364 8.127 6.591 15 15 15z",
    fill: "#636978"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m316.25 179.5c7.846 0 15.363-6.899 15-15-.364-8.127-6.591-15-15-15-7.846 0-15.363 6.899-15 15 .364 8.127 6.591 15 15 15z",
    fill: "#636978"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m406.625 179.5c7.846 0 15.363-6.899 15-15-.364-8.127-6.591-15-15-15-7.846 0-15.363 6.899-15 15 .364 8.127 6.591 15 15 15z",
    fill: "#414952"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m331.25 164.5c-.364-8.127-6.591-15-15-15v30c7.846 0 15.363-6.899 15-15z",
    fill: "#414952"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectChatOrderTracking);
export default __webpack_public_path__ + "static/media/direct-chat-order-tracking.97af4cfb38be13f68d0e1f881bce1eec.svg";
export { ForwardRef as ReactComponent };